jQuery(function ($) {
    'use strict';

    const $containerForm = $('.woocommerce-edit-account #edit-account-info')

    if (!$containerForm.length) {
        return;
    }

    const $editButtons = $containerForm.find('.edit-button');
    const $cancelButtons = $containerForm.find('.cancel-button');
    const $saveButtons = $containerForm.find('.save-button');

    // Helper function to get row elements based on field slug
    function getRowElements($triggerElement) {
        const fieldSlug = $triggerElement.data('field');
        const $row = $triggerElement.parents('.row-group');

        return {
            fieldSlug,
            $row,
            $input: $row.find('.row-group__input'),
            $text: $row.find('.row-group__value'),
            $editBtn: $row.find('.edit-button'),
            $saveBtn: $row.find('.save-button'),
            $cancelBtn: $row.find('.cancel-button')
        };
    }

    function saveField($triggerElement) {
        const { fieldSlug, $row, $input, $text, $editBtn, $saveBtn, $cancelBtn } = getRowElements($triggerElement);

        const formData = new FormData($containerForm[0]);

        // Prepare data for specific field update
        const fieldData = {
            action: 'save_account_details',
            field_name: fieldSlug,
            'save-account-details-nonce': formData.get('save-account-details-nonce')
        };

        // Handle different field types
        if (fieldSlug === 'account_password') {
            // For password, collect all three password fields
            fieldData['password_current'] = $containerForm.find('#password_current').val();
            fieldData['password_1'] = $containerForm.find('#password_1').val();
            fieldData['password_2'] = $containerForm.find('#password_2').val();
        } else {
            // For other fields, add the input value
            fieldData[fieldSlug] = $input.val();
        }

        // Show loading state
        $row.addClass('is-saving');
        $saveBtn.prop('disabled', true);
        $cancelBtn.prop('disabled', true);

        $.ajax({
            url: woocommerce_params?.ajax_url || '',
            type: 'POST',
            dataType: 'json',
            data: fieldData,
            success: function (response) {
                if (response.success) {
                    // Update displayed value
                    if (fieldSlug === 'account_password') {
                        // Reset password section UI
                        $containerForm.find('#password_current, #password_1, #password_2').val('');
                        $containerForm.find('.row-group--password fieldset').addClass('hide');
                        $row.find('.row-group--password').removeClass('placeholder-hidden');
                        $row.find('.row-group__edit-btn').show();
                        $row.removeClass('placeholder-name');
                    } else {
                        $text.find('strong').text($input.val());
                    }

                    // Reset UI state for non-password fields
                    $input.addClass('hide');
                    $saveBtn.addClass('hide');
                    $cancelBtn.addClass('hide');
                    $editBtn.show();
                    $text.show();
                    $row.removeClass('placeholder-hidden placeholder-name');
                } else {
                    // Show error message
                    alert(response.data?.message || 'Failed to save changes');
                }
            },
            error: function () {
                // Show error state briefly
                $row.addClass('has-error');
                setTimeout(() => $row.removeClass('has-error'), 2000);

                alert('An error occurred while saving');
            },
            complete: function () {
                // Reset loading state
                $row.removeClass('is-saving');
                $saveBtn.prop('disabled', false);
                $cancelBtn.prop('disabled', false);
            }
        });
    }

    function focusInput($input) {
        if ($input?.length > 0) {
            $input.focus();
            $input[0]?.setSelectionRange?.($input.val().length, $input.val().length);
        }
    }

    $editButtons.on('click', function (e) {
        e.preventDefault();

        const { fieldSlug, $row, $input, $text, $editBtn, $saveBtn, $cancelBtn } = getRowElements($(this));

        if ('account_password' === fieldSlug) {
            $containerForm.find('.row-group--password fieldset').removeClass('hide');
            $(this).parents('.row-group--password').addClass('placeholder-hidden');
        }

        $input.removeClass('hide');
        focusInput($input);
        $cancelBtn.removeClass('hide');
        $saveBtn.removeClass('hide');

        $editBtn.hide();
        $text.hide();

        $row.addClass('placeholder-name');
    });

    $cancelButtons.on('click', function (e) {
        e.preventDefault();

        const { fieldSlug, $row, $input, $text, $editBtn, $saveBtn } = getRowElements($(this));

        if ('account_password' === fieldSlug) {
            $containerForm.find('.row-group--password fieldset').addClass('hide');
            $(this).parents('.row-group--password').removeClass('placeholder-hidden');
        }

        $(this).addClass('hide');
        $saveBtn.addClass('hide');
        $input.addClass('hide');
        $editBtn.show();
        $text.show();

        $row.removeClass('placeholder-name');
    });

    $saveButtons.on('click', function (e) {
        e.preventDefault();
        saveField($(this));
    });

    // Handle Enter key press on inputs
    $containerForm.on('keypress', '.row-group__input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            const $row = $(this).parents('.row-group');
            const $saveBtn = $row.find('.save-button');
            saveField($saveBtn);
        }
    });

    //Delete an account with confirmation
    $('#delete-account').on('click', function (e) {
        let confirm_text = $(this).data('confirm');
        return confirm(confirm_text);
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const loginTabs = document.querySelectorAll('.login-page__tabs');
    if(loginTabs) {
        const titles = document.querySelectorAll('.tabs__title');
        const bodies = document.querySelectorAll('.tabs__body');
      
        function setActiveTab(index) {
          titles.forEach((btn, i) => {
            btn.classList.toggle('active', i === index);
            bodies[i].classList.toggle('active', i === index);
          });
        }
      
        setActiveTab(0);
      
        titles.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            setActiveTab(index);
          });
        });
    }
  });